import NotFound from '../../../pages/not-found';
import i18next from 'i18next';
import permissions from '@shared/config/permissions';
import AllergiEndResourcesLogo from '../../../_legacy/components/Shared/Icons/AllergiEndResourcesLogo';

export const EXTERNAL_ROUTES = {
  // allergiEndResources: {
  //   externalReference: true,
  //   path:
  //     'https://drive.google.com/drive/u/4/folders/1g_jpa1rkycfdaq-NizLUZkFQZ-tDaagK',
  //   exact: true,
  //   additional: {
  //     component: NotFound,
  //     protected: true,
  //     title: i18next.t('titles:allergiEndResources'),
  //     icon: AllergiEndResourcesLogo,
  //     permission: permissions.ACCOUNT_GET_ALLERGIEND_RESOURCES,
  //   },
  // },
};


